import { NgModule, NgModuleFactoryLoader, Component } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { BrowserModule } from '@angular/platform-browser';
import { UIRouterModule, Transition } from "@uirouter/angular";
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Http, RequestOptions, HttpModule } from '@angular/http';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap'
import { MomentModule } from 'angular2-moment';
import { CookieService } from 'ng2-cookies';

import { ApiService } from './api-service/api.service';
import { MailboxService } from './mailbox-service/mailbox.service';
import { ProfileService } from './profile-service/profile.service';
import { ClientConfigService } from './client-config-service/client-config.service';
import { CustomerService } from './customer-service/customer.service';
import { ProductsService } from './products-service/products.service';
import { RewardsService } from './rewards-service/rewards.service';
import { AuditTrailService } from './audit-trail-service/audit-trail.service';

import { JwtHelper, AuthHttp, AuthConfig } from 'angular2-jwt'

import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ReissueComponent } from './reissue/reissue.component';
import { MailboxEmailComponent } from './mailbox-email/mailbox-email.component';
import { MailboxOverlayComponent } from './mailbox-overlay/mailbox-overlay.component';
import { MailboxReplyComponent } from './mailbox-reply/mailbox-reply.component';
import { MailboxPreviewComponent } from './mailbox-preview/mailbox-preview.component';
import { MailboxComponent } from './mailbox/mailbox.component';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { CustomNgbDateParserFormatter } from './datepicker/custom-NgbDateParserFormatter';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { AuditTrailOverlayComponent } from './audit-trail-overlay/audit-trail-overlay.component';
import { AuditTrailItemsComponent } from './audit-trail-items/audit-trail-items.component';
import { RewardsComponent } from './rewards/rewards.component';
import { RewardsEditOverlayComponent } from './rewards-edit-overlay/rewards-edit-overlay.component';

// The root Angular module
@NgModule({
  imports: [
    BrowserModule,
    // Provide Angular upgrade capabilities
    UpgradeModule,
    // Provides the @uirouter/angular-hybrid directives
    UIRouterUpgradeModule,
    // Provides the @uirouter/angular directives
    UIRouterModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    // Moment module for datetime formatting
    MomentModule,
    NgbModule.forRoot()
  ],
  declarations: [AppComponent, SidebarComponent, ReissueComponent, MailboxEmailComponent, MailboxOverlayComponent, MailboxReplyComponent, MailboxPreviewComponent, MailboxComponent, AuditTrailComponent, DatepickerComponent, TimepickerComponent, AuditTrailOverlayComponent, AuditTrailItemsComponent, RewardsComponent, RewardsEditOverlayComponent, ],
    entryComponents: [AppComponent, SidebarComponent, ReissueComponent, MailboxComponent, MailboxEmailComponent, MailboxPreviewComponent, MailboxOverlayComponent, MailboxReplyComponent, AuditTrailComponent, AuditTrailOverlayComponent, RewardsComponent,RewardsEditOverlayComponent, ],
    providers: [HttpClient, ApiService, JwtHelper, MailboxService, ProfileService, ClientConfigService, ProductsService,
    CustomerService, AuditTrailService, CookieService, RewardsService,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions, CookieService]
    },

    {
      provide: NgbDateParserFormatter, 
      useFactory: ngbFactory
    }
    ]
}) 

export class AppModule {

  ngDoBootstrap(){
     /* no body: this disables normal (non-hybrid) Angular bootstrapping */
  }

}

export function ngbFactory(){
  return new CustomNgbDateParserFormatter('dd/MM/yyyy');
}

export function authHttpServiceFactory(http: Http, options: RequestOptions, cookie: CookieService) {

  return new AuthHttp(new AuthConfig({
    noTokenScheme: true,
    tokenName: 'membrs',
    tokenGetter: (() => cookie.get('membrs')),
    headerName: 'X-Authorization'
  }), http, options);
}


// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/app.module.ts